import styles from './TopicCard.module.css';

const TopicCard = ({ title, description }) => {
  return (
    <div className={styles.card}>
      <h3>{title}</h3>

      <p>{description}</p>
    </div>
  );
};

export default TopicCard;